import React, { Component } from "react";

const CurveOverImage = ({ width, height, fill,style }) => {
  return (
    <svg
      width={width}
      height="61"
      viewBox={`0 0 ${width} 61`}
      fill="none"
      style={style}
    >
      <path
        d={`M${width} 43.2735V0H0V43.2735C0 43.2735 95.3056 61 180 61C264.694 61 ${width} 43.2735 ${width} 43.2735Z`}
        fill={fill}
      />
    </svg>
  );
};

CurveOverImage.defaultProps = {
  height: 38,
  width: 360,
  fill: "black",
};

export default CurveOverImage;
